import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MDTypography from 'components/MDTypography';
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import MDBox from 'components/MDBox';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: 'dark' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? "#adb5bd"
      : "#F2EFF8",
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function AccordionGroup({data, system}) {
  const [expanded, setExpanded] = React.useState(null);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      {data.map((value, index) => (
      <Accordion expanded={expanded === index} onChange={handleChange(index)}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <MDTypography variant="caption" fontWeight="regular" color="dark">
          {value['question_title']}
          </MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <MDTypography display="block"  variant="caption" fontWeight="medium" mr={3}>
              {"Q: "+ value['question_description']}
            </MDTypography>
            {!system &&
            <MDBox display="flex">
              <MDButton variant="caption" color="dark" size="small" iconOnly={true}>
                <Icon sx={{ fontWeight: "medium" }}>add</Icon>
              </MDButton>
              <MDButton variant="caption" color="error" size="small" iconOnly={true}>
                <Icon sx={{ fontWeight: "medium" }}>delete</Icon>
              </MDButton>
            </MDBox>
            }
          </MDBox>
          {value['question_ranges'].map((option, index) => (
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography display="block" variant="caption" fontWeight="regular" key={"option"+index} ml={2}>
                  {option}
                </MDTypography>
                {!system &&
                <MDBox>
                  <MDButton variant="text" color="text" size="small" iconOnly={true}>
                    <Icon size="sm">edit</Icon>
                  </MDButton>
                  <MDButton variant="text" color="text" size="small" iconOnly={true}>
                    <Icon size="sm">delete</Icon>
                  </MDButton>
                </MDBox>
                }
              </MDBox>
          ))}
        </AccordionDetails>
      </Accordion>
      ))}
    </div>
  );
}